var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWidgetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.56636 28.2228C6.30318 28.7622 8.25656 28.3313 9.59589 27.0364C9.92589 26.7173 10.4195 26.637 10.8336 26.8351C12.512 27.6376 14.3146 28.0325 16.1917 28.0024C22.8229 27.9037 28.0173 22.6325 28.0173 16.0017C28.0173 9.51576 22.7409 4.13288 16.2555 4.00239C9.5719 3.86953 4.01614 9.28263 4.00002 15.9723C3.99652 17.4109 4.37218 18.6546 4.75742 19.9302C4.94581 20.5539 5.13649 21.1853 5.28625 21.8507C5.76715 23.9875 5.5137 26.247 4.56636 28.2228ZM11.5 16C11.5 16.8284 10.8284 17.5 10 17.5C9.17157 17.5 8.5 16.8284 8.5 16C8.5 15.1716 9.17157 14.5 10 14.5C10.8284 14.5 11.5 15.1716 11.5 16ZM16 17.5C16.8284 17.5 17.5 16.8284 17.5 16C17.5 15.1716 16.8284 14.5 16 14.5C15.1716 14.5 14.5 15.1716 14.5 16C14.5 16.8284 15.1716 17.5 16 17.5ZM22 17.5C22.8284 17.5 23.5 16.8284 23.5 16C23.5 15.1716 22.8284 14.5 22 14.5C21.1716 14.5 20.5 15.1716 20.5 16C20.5 16.8284 21.1716 17.5 22 17.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetIcon);
export default __webpack_public_path__ + "static/media/widget-icon.09b63ead6733ecba6644176a23f20959.svg";
export { ForwardRef as ReactComponent };